import React, { useState, useEffect } from "react";
import { Typography, Icon } from "@mui/material";
import moment from "moment";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { PROFILE } from "../../redux/constant";

import { StepLabel, CustomButton, CustomInput } from "../../../components";
import { updateProfile, hideError } from "../../redux/action";
import { allowedIdType } from "../../../utils/allowedIdType";
import styles from "../styles";

const PoliticalPosition = ({ profile, loading, updateProfile, history }) => {
  const [isPEP, setIsPEP] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [isTax, setIsTax] = useState(false);

  const localIdentity = profile?.identities?.find(allowedIdType);

  useEffect(() => {
    if (profile) {
      setUserInfo(profile);
    }
  }, [profile]);

  useEffect(() => {
    if (userInfo) {
      setIsPEP(userInfo.pepFlag);
      setIsTax(
        userInfo.identities &&
          userInfo.identities.find(identity => identity.idTypeCd === "TAX")
          ? true
          : false
      );
    }
  }, [userInfo]);

  const handleUpdate = () => {
    const payload = {
      masterId: userInfo.masterId, //R
      email: userInfo.email, //R
      mobileNo: userInfo.mobileNo, //R
      fullName: userInfo.fullName, //R
      townOfBirth: userInfo.townOfBirth, //R
      dob: moment(userInfo.dob).format("YYYY-MM-DD"), //R
      race: userInfo.race, //R
      natureOfBusinessCd: userInfo.natureOfBusinessCd, //R
      occupationTypeCd: userInfo.occupationTypeCd, //R
      maritalStatusCd: userInfo.maritalStatusCd, //R
      yearlyIncomeLevelCd: userInfo.yearlyIncomeLevelCd, //R
      sourceOfFundCd: userInfo.sourceOfFundCd,
      investmentObjCd: userInfo.investmentObjCd,
      employerName: userInfo.employerName,
      pepFlag: isPEP,
      identities:
        isTax === true
          ? [
              {
                idTypeCd: localIdentity?.idTypeCd, //R
                idNo: localIdentity?.idNo, //R
                citizenship: localIdentity?.citizenship //R
              },
              {
                idTypeCd: "TAX", //R
                idNo: userInfo.identities.find(
                  identity => identity.idTypeCd === "TAX"
                ).idNo, //R
                citizenship: userInfo.identities.find(
                  identity => identity.idTypeCd === "TAX"
                ).citizenship //R
              }
            ]
          : [
              {
                idTypeCd: localIdentity?.idTypeCd, //R
                idNo: localIdentity?.idNo, //R
                citizenship: localIdentity?.citizenship //R
              }
            ],
      address: {
        line1: userInfo.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        line2: userInfo.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line2,
        line3: userInfo.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line3,
        postCode: userInfo.contacts.find(contact => contact.postCode).postCode, //R
        city: userInfo.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).city, //R
        state: userInfo.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship //R
      }
    };

    // window.consoleLog(payload);
    updateProfile({ payloadData: payload, from: PROFILE });
  };

  const handleChange = e => {
    setIsPEP(e.target.value);
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      <StepLabel
        title="Update Info"
        containerStyles={{
          margin: "16px 16px 24px",
          alignItems: "flex-start"
        }}
        onClick={() => history.back()}
      />
      <div style={{ margin: "0 16px" }}>
        <CustomInput
          label="Do you hold a position (or related to such persons) in any Public or Political offices, Including being its committee or council member"
          name="isPEP"
          value={isPEP}
          onChange={handleChange}
          isEdit={true}
          isRequired={false}
          isRadio={true}
        />
      </div>
      <div style={styles.btnContainer}>
        <CustomButton
          text="Save"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={isPEP ? false : true}
          onClick={handleUpdate}
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    profile: state.goal.profile
  }),
  {
    updateProfile
  }
);

export default compose(
  withRouter,
  withConnect
)(PoliticalPosition);
